/**
 * `/games/pc/games` 세 섹션이 공유하는 폭·간격 토큰 (개정 시안 `29889:100225` 데스크탑 ·
 * `29942:16125` 모바일).
 *
 * ## 왜 상수로 빼나
 *
 * 세 섹션이 **같은 좌우 여백에 정렬돼야** 한다 — 시안에서 `type-intro` · `upcoming-new` ·
 * `list-module` 이 전부 `px-240`(데스크탑) · `px-16`(모바일)이다. 각 파일이 따로 적으면
 * 한 섹션만 고쳤을 때 조용히 어긋난다(형제 화면 `pc-overview` 가 같은 이유로 뺐다).
 *
 * ⚠️ **`justify-center` + `mx-4 flex-1 min-w-0 max-w-screen-max` 규약이다.**
 * `mx-auto ... px-4` 로 쓰면 `max-w` **안쪽이** 깎여 1920 에서 콘텐츠가 1440 이 아니라
 * 1376 이 된다 — 사유 원문은 `PcOverviewHero.tsx`.
 */
export const PC_GAMES_CONTAINER =
  "mx-4 flex min-w-0 max-w-screen-max flex-1 flex-col";

/**
 * 섹션 **사이** 간격. 시안 좌표에서 낸 값이다 — 앞 섹션의 높이를 빼야 갭이 나온다
 * (`docs/pitfalls.md` #40).
 *
 * ```
 *                              데스크탑 `29889:100225`        모바일 `29942:16125`
 *   subnav → type-intro        subnav 끝 0 → y96      = 96    body y112 → y48 상대  = 48
 *   type-intro → upcoming-new  96+276=372 → 468       = 96    48+464=512 → 560      = 48
 *   upcoming-new → list-module 468+448=916 → 1012     = 96    560+342=902 → 950     = 48
 *   list-module → Footer       1012+1003=2015 → 2111  = 96    950+1008=1958 → 2006  = 48
 * ```
 *
 * **네 간격이 폭마다 한 값으로 균일**하다. 그래서 섹션마다 `py-` 를 따로 주지 않고
 * 페이지 조립부가 `gap` 하나로 준다 — 섹션이 자기 여백을 가지면 인접 두 섹션의 여백이
 * 더해져 시안의 두 배가 된다(종전 구현이 `py-12 laptop:py-[72px]` 라 실측 144 였다).
 */
export const PC_GAMES_SECTION_GAP = "gap-12 laptop:gap-24";
